// src/hooks/useHandleAutoLogout.js
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthDispatchers } from "@store/dispatchers";

const useHandleAutoLogout = () => {
  const { handleLogout } = useAuthDispatchers();
  const navigate = useNavigate();

  const onAutoLogout = useCallback(
    ({ redirect = true } = {}) => {
      localStorage.setItem("is_forced_sign_out", "true");
      localStorage.removeItem("consentModalDismiss");

      handleLogout();

      if (redirect) navigate("/login");
    },
    [handleLogout, navigate]
  );

  return { onAutoLogout };
};

export default useHandleAutoLogout;
